<div class="tpl3pl-page-container">
	<div class="tpl3pl-toolbar">
		<div class="tpl3pl-toolbar-filters"></div>
		<div class="tpl3pl-toolbar-actions">
			<button mat-stroked-button (click)="openRawRequestResponse()" [disabled]="rawLoading" matTooltip="View raw request/response from 3PL API">
				<mat-spinner *ngIf="rawLoading" diameter="20"></mat-spinner>
				<mat-icon *ngIf="!rawLoading">visibility</mat-icon> View raw request / response
			</button>
			<button mat-raised-button color="primary" (click)="loadOpenOrders()" [disabled]="loading">
				<mat-icon>refresh</mat-icon> Refresh
			</button>
		</div>
	</div>

	<div *ngIf="errorMessage" class="alert alert-warning mb-3">{{ errorMessage }}</div>

	<div class="table-responsive position-relative tpl3pl-table-wrapper">
		<div *ngIf="loading" class="tpl3pl-loading-overlay">
			<mat-spinner diameter="48"></mat-spinner>
			<p class="mt-2 mb-0">Loading…</p>
		</div>
		<table mat-table [dataSource]="dataSource" class="w-100" matSort [class.tpl3pl-loading-opacity]="loading">
			<ng-container matColumnDef="pgs_orderno">
				<th mat-header-cell *matHeaderCellDef mat-sort-header>PGS Order ID</th>
				<td mat-cell *matCellDef="let item">{{ item.pgS_OrderNo ?? item.pgs_orderno ?? item.PgsOrderNo ?? '-' }}</td>
			</ng-container>
			<ng-container matColumnDef="status">
				<th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
				<td mat-cell *matCellDef="let item">
					<span class="badge" [ngClass]="getStatusBadgeClass(item)">{{ item.status ?? item.Status ?? item.OrderStatus ?? '-' }}</span>
				</td>
			</ng-container>
			<ng-container matColumnDef="so">
				<th mat-header-cell *matHeaderCellDef mat-sort-header>SO</th>
				<td mat-cell *matCellDef="let item">{{ item.so ?? '-' }}</td>
			</ng-container>
			<ng-container matColumnDef="po">
				<th mat-header-cell *matHeaderCellDef mat-sort-header>PO</th>
				<td mat-cell *matCellDef="let item">{{ item.po ?? '-' }}</td>
			</ng-container>
			<ng-container matColumnDef="consignee">
				<th mat-header-cell *matHeaderCellDef mat-sort-header>Consignee</th>
				<td mat-cell *matCellDef="let item" class="consignee-cell">{{ item.consignee ?? '-' }}</td>
			</ng-container>
			<ng-container matColumnDef="destination">
				<th mat-header-cell *matHeaderCellDef mat-sort-header>Destination</th>
				<td mat-cell *matCellDef="let item" class="destination-cell" [matTooltip]="(item.destination ?? '') || '–'">{{ item.destination ?? '-' }}</td>
			</ng-container>
			<ng-container matColumnDef="warehouse">
				<th mat-header-cell *matHeaderCellDef mat-sort-header>Warehouse</th>
				<td mat-cell *matCellDef="let item" class="warehouse-cell">{{ item.warehouse ?? '-' }}</td>
			</ng-container>
			<ng-container matColumnDef="createddate">
				<th mat-header-cell *matHeaderCellDef mat-sort-header>Created</th>
				<td mat-cell *matCellDef="let item">{{ formatDate(item.createdDate ?? item.createddate ?? item.CreatedDate) }}</td>
			</ng-container>
			<ng-container matColumnDef="RoutedDate">
				<th mat-header-cell *matHeaderCellDef mat-sort-header>Routed</th>
				<td mat-cell *matCellDef="let item">{{ formatDate(item.routedDate ?? item.RoutedDate) }}</td>
			</ng-container>
			<ng-container matColumnDef="ScheduledPickUpDate">
				<th mat-header-cell *matHeaderCellDef mat-sort-header>Scheduled Pickup</th>
				<td mat-cell *matCellDef="let item">{{ formatDate(item.scheduledPickUpDate ?? item.ScheduledPickUpDate) }}</td>
			</ng-container>

			<tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
			<tr
				mat-row
				*matRowDef="let row; columns: displayedColumns"
				class="tpl3pl-open-orders-row"
				[class.tpl3pl-open-orders-row--clickable]="!!resolveErpOrderNo(row)"
				(click)="onTableRowClick(row, $event)"
			></tr>
			<tr class="mat-row" *matNoDataRow>
				<td class="mat-cell text-center text-muted py-4" [attr.colspan]="displayedColumns.length">
					{{ loading ? '' : 'No open B2B orders.' }}
				</td>
			</tr>
		</table>
		<mat-paginator [pageSizeOptions]="[10, 25, 50, 100]"></mat-paginator>
	</div>
</div>
